export default "__VITE_ASSET__B5sBMT2L__"